/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Updated_SuccessInputs */



/**
* | output |
* | --- |
* | "Issue updated successfully" |
*
* @param {Manual_Qc_Updated_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_updated_success = /** @type {((inputs?: Manual_Qc_Updated_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Updated_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Incident mis a jour avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Problem erfolgreich aktualisiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problema aggiornato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проблема успешно обновлена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problema actualizado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("问题已成功更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題が正常に更新されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समस्या सफलतापूर्वक अपडेट हो गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Problema resolvido com sucesso")
	return /** @type {LocalizedString} */ ("Issue updated successfully")
});